import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    status: 'VIEW',     //VIEW,INSERT,UPDATE
    wait: false,        //back drop
    waitcursor:false,   //waitcursor
    success: false,     //snackbar
    successmsg: '',
    warnning: false,    //snackbar
    warndiscription: [], //warninng data
    warnmessage: "",     //warninng title
    convdiscription: [], //convert data
    modify: false,       //List Modify flag
    entryformlock: false, //Entry Form lock
    entryinputrender: false, //Entry Form 強制render ※Entry Input 関連フィールド更新用
    entrytriggercall: false,  //他パネルからTriggerの起動
    entrytriggerfield: "",    //Triigger項目
    applylinkfield: false,  //関連フィールドの更新を実行　※Entry Input 関連フィールド更新用
    applyfieldid: '',    //関連フィールド更新を行うID
    listtabs: [],         //SubTable TAB
    listoption: [],         //ListOption
    gridtab:"0",        //gridtabvalue
    reports: [],         //帳票
    storagename: "",
    storageupdate: false,
    prestoragename: "",
    entrylayoutopen: false,  //EntryLayout openflag
    entrylayouttype: 100,
    entrysettingopen: false,  //EntrySetting openflag
    datatreeopen: false,    //Data Tree openflag
    datatreelist: [],
    readonly: false,         //true:読込専用
    ctrls: "",                //制御
    menuinfo: {},            //起動メニュ情報
    changeurl:[],            //変換WEBAPI情報 
    callstatus: 'VIEW',      //Entry Call Status
    masonrydata: [],  //Masonry data
    themestyle: {
        maincolor: '#93A5A1', body: { 'back': '#F8F8F8', 'color': '#000', 'accentback': "#D3E6E2", 'accentfore':'#000', 'require': "rgba(248,149,91,0.1)" }, header: { 'base': 'agex1_1', 'myfd': 'agmf1_1', 'back':'#93A5A1', 'color':'#FFF'}
    },
    opentheme: false,
    entrydata:[],           //Headline使用 ※変更値参照
    rerendergrid: [],
    gridlist:[],            //Grid List
    gridmaximize: {}        //GridPanel最大化
};

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        changestatus: (state, action) => {
            if (action.payload.indexOf("FORM") !== -1) {
                let callform = state.status;
                return Object.assign({}, state, {
                    status: action.payload,
                    callstatus: callform
                })
            } else {
                return Object.assign({}, state, {
                    status: action.payload
                })
            }
        },
        wait: (state, action) => {
            if (action.payload) {
                return Object.assign({}, state, {
                    wait: action.payload
                })
            } else {
                //同時に無効化（既存影響考慮）
                return Object.assign({}, state, {
                    wait: action.payload,
                    waitcursor: action.payload
               })
            }
        },
        waitcursor: (state, action) => {
            return Object.assign({}, state, {
                waitcursor: action.payload
            })
        },
        success: (state, action) => {
            return Object.assign({}, state, {
                success: action.payload,
                successmsg:'Success!'
            })
        },
        successmsg: (state, action) => {
            return Object.assign({}, state, {
                success: true,
                successmsg: action.payload
            })
        },
        warnning: (state, action) => {
            return Object.assign({}, state, {
                warnning: action.payload
            })
        },
        clearwardescription: (state, action) => {
            return Object.assign({}, state, {
                warndiscription: [],
                convdiscription:[]
            })
        },
        showwarndescription: (state, action) => {
            return Object.assign({}, state, {
                warnning: true,
                warnmessage: action.payload.msg,
                warndiscription: action.payload.warnlist
            })
        },
        clearconvdescription: (state, action) => {
            return Object.assign({}, state, {
                convdiscription: []
            })
        },
        showconvdescription: (state, action) => {
            return Object.assign({}, state, {
                convdiscription: action.payload
            })
        },
        modify: (state, action) => {
            return Object.assign({}, state, {
                modify: action.payload
            })
        },
        gridtabvalue: (state, action) => {
            return Object.assign({}, state, {
                gridtab: action.payload
            })
        },
        listtabs: (state, action) => {
            return Object.assign({}, state, {
                listtabs: action.payload
            })
        },
        listoption: (state, action) => {
            return Object.assign({}, state, {
                listoption: action.payload
            })
        },
        reports: (state, action) => {
            return Object.assign({}, state, {
                reports: action.payload
            })
        },
        setgridlist: (state, action) => {
            return Object.assign({}, state, {
                gridlist: action.payload
            })
        },
        setstoragename: (state, action) => {
            if (action.payload.storagename !== "") 
                return Object.assign({}, state, {
                    storagename: action.payload.storagename,
                    storageupdate: action.payload.storageupdate,
                    prestoragename: action.payload.storagename
                })
            else
                return Object.assign({}, state, {
                    storagename: action.payload.storagename,
                    storageupdate: action.payload.storageupdate
                })
        },
        setprestorage: (state, action) => {
            return Object.assign({}, state, {
                prestoragename: action.payload
            })
        },
        entrylayoutopen: (state, action) => {
            return Object.assign({}, state, {
                entrylayoutopen: true,
                entrylayouttype: action.payload
            })
        },
        entrylayoutclose: (state, action) => {
            return Object.assign({}, state, {
                entrylayoutopen: false,
            })
        },
        entrysettingopen: (state, action) => {
            return Object.assign({}, state, {
                entrysettingopen: action.payload,
            })
        },
        masonrydata: (state, action) => {
            return Object.assign({}, state, {
                masonrydata: action.payload,
            })
        },
        entrydata: (state, action) => {
            return Object.assign({}, state, {
                entrydata: action.payload,
            })
        },
        clearform: (state, action) => {
            //ListTab,prestoragenameのみクリアしない
            return Object.assign({}, state, {
                status: 'VIEW',     //VIEW,INSERT,UPDATE
                wait: false,        //back drop
                success: false,     //snackbar
                successmsg: '',
                warnning: false,    //snackbar
                warndiscription: [], //warninng data
                warnmessage: "",     //warninng title
                convdiscription: [], //convert data
                modify: false,       //Entry Form Modify flag
                storagename: action.payload ? "" : state.storagename
            })
        },
        clearform2: (state, action) => {
            //status保持　ListTab,prestoragenameのみクリアしない
            return Object.assign({}, state, {
                wait: false,        //back drop
                success: false,     //snackbar
                successmsg: '',
                warnning: false,    //snackbar
                warndiscription: [], //warninng data
                warnmessage: "",     //warninng title
                convdiscription: [], //convert data
                modify: false,       //Entry Form Modify flag
                storagename: ""
            })
        },
        entryformlock: (state, action) => {
            //readonly=trueの場合強制ロック
            return Object.assign({}, state, {
                entryformlock: state.readonly?true:action.payload,
            })
        },
        entryrerender: (state, action) => {
            return Object.assign({}, state, {
                entryinputrender: !state.entryinputrender,
            })
        },
        entrytriggercall: (state, action) => {
            return Object.assign({}, state, {
                entrytriggercall: !state.entrytriggercall,
                entrytriggerfield: action.payload,
            })
        },
        applylinkfield: (state, action) => {
            return Object.assign({}, state, {
                applylinkfield: !state.applylinkfield,
                applyfieldid: action.payload,
            })
        },
        datatreeopen: (state, action) => {
            return Object.assign({}, state, {
                datatreeopen: action.payload.datatreeopen,
                datatreelist: action.payload.datatreelist,
            })
        },
        clearentrytrigger: (state, action) => {
            return Object.assign({}, state, {
                entrytriggerfield: "",
            })
        },
        readonly: (state, action) => {
            return Object.assign({}, state, {
                readonly: action.payload.readonly,
                entryformlock: action.payload.readonly,
                ctrls: action.payload.ctrls,
            })
        },
        setctrl: (state, action) => {
            return Object.assign({}, state, {
                ctrls: action.payload
            })
        },
        setchangeurl: (state, action) => {
            return Object.assign({}, state, {
                changeurl: action.payload
            })
        },
        setmenuinfo: (state, action) => {
            return Object.assign({}, state, {
                menuinfo: action.payload,
                ctrls: action.payload.ctrls,
                readonly: action.payload.ro,
           })
        },
        themestyle: (state, action) => {
            return Object.assign({}, state, {
                themestyle: action.payload
            })
        },
        opentheme: (state, action) => {
            return Object.assign({}, state, {
                opentheme: action.payload
            })
        },
        rerendergrid: (state, action) => {
            let grid = [];
            for (let i = 0; i < state.rerendergrid.length; i++) {
                grid.push(state.rerendergrid[i]);
            }
            grid.push(action.payload.rerendergrid)
            return Object.assign({}, state, {
                rerendergrid: grid
            })
        },
        removererendergrid: (state, action) => {
            let grid = [];
            for (let i = 0; i < state.rerendergrid.length; i++) {
                if (state.rerendergrid[i] !== action.payload.rerendergrid) {
                    grid.push(state.rerendergrid[i]);
                }
            }
            return Object.assign({}, state, {
                rerendergrid: grid
            })
        },
        gridmaximize: (state, action) => {
            let v = action.payload;
            return Object.assign({}, state, {
                gridmaximize: action.payload
            })
        },
        setgridmaximize: (state, action) => {
            const newvalue = JSON.parse(JSON.stringify(state.gridmaximize));
            newvalue[action.payload.id] = action.payload.flag;
            return Object.assign({}, state, {
                gridmaximize: newvalue
            })
        },
        resetform: (state, action) => {
            return initialState;
        }
    },
});

export const {
    changestatus, wait, success, warnning, showwarndescription, clearwardescription, modify, resetform, setgridlist,
    clearform, clearform2,showconvdescription, clearconvdescription, successmsg, listtabs, reports,setstoragename, setprestorage,
    entrylayoutopen, entrylayoutclose, entrysettingopen, masonrydata, entryformlock, entryrerender, entrydata,
    entrytriggercall, clearentrytrigger, datatreeopen, readonly, themestyle, opentheme, setctrl, gridtabvalue, setmenuinfo,
    rerendergrid, removererendergrid, applylinkfield, gridmaximize, setgridmaximize, listoption, setchangeurl, waitcursor
} = formSlice.actions

export default formSlice;

